"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var naturalnessHelpers_exports = {};
__export(naturalnessHelpers_exports, {
  drnAttribution: () => drnAttribution,
  neLakeNaturalnessLayer: () => neLakeNaturalnessLayer,
  neLakeNaturalnessSource: () => neLakeNaturalnessSource,
  neRiverNaturalnessLayer: () => neRiverNaturalnessLayer,
  neRiverNaturalnessSource: () => neRiverNaturalnessSource,
  priorityLakeHabitatLayer: () => priorityLakeHabitatLayer,
  priorityRiverHabitatLayer: () => priorityRiverHabitatLayer
});
module.exports = __toCommonJS(naturalnessHelpers_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_geometry = require("@cartographerio/geometry");
var import_core = require("../../core/index.js");
const priorityHabitatColor = "#00ccff";
function naturalnessBuckets(category) {
  return (0, import_topo_map.standardBuckets)([
    (0, import_topo_map.lookupBucket)(1, import_topo_map.marker.quality(0.7), `1 (high ${category} naturalness)`),
    (0, import_topo_map.lookupBucket)(2, import_topo_map.marker.quality(0.6), "2"),
    (0, import_topo_map.lookupBucket)(3, import_topo_map.marker.quality(0.5), "3"),
    (0, import_topo_map.lookupBucket)(4, import_topo_map.marker.quality(0.4), "4"),
    (0, import_topo_map.lookupBucket)(5, import_topo_map.marker.quality(0.3), `5 (very low ${category} naturalness!)`)
  ]);
}
const naturalnessAttributes = (0, import_topo_map.attributeGroup)({
  label: "Naturalness Components",
  attributes: [
    (0, import_topo_map.numberAttr)({
      attributeId: "physical",
      label: "Physical",
      buckets: naturalnessBuckets("physical")
    }),
    (0, import_topo_map.numberAttr)({
      attributeId: "hydrological",
      label: "Hydrological",
      buckets: naturalnessBuckets("hydrological")
    }),
    (0, import_topo_map.numberAttr)({
      attributeId: "chemical",
      label: "Chemical",
      buckets: naturalnessBuckets("chemical")
    }),
    (0, import_topo_map.numberAttr)({
      attributeId: "biological",
      label: "Biological",
      buckets: naturalnessBuckets("biological")
    })
  ]
});
const neLakeNaturalnessSource = (0, import_core.cartographerSourceWithDefaults)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neLakeNaturalness"),
  simplifyZoom: 10,
  attribution: []
});
const neRiverNaturalnessSource = (0, import_core.cartographerSourceWithDefaults)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neRiverNaturalness"),
  simplifyZoom: 10,
  attribution: []
});
const neRiverNaturalnessLayer = (0, import_topo_map.lineLayer)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neRiverNaturalness"),
  title: "New River Naturalness Data",
  source: neRiverNaturalnessSource,
  defaultAttribute: "physical",
  attributes: [
    (0, import_topo_map.attributeGroup)({
      label: "Location",
      attributes: [
        (0, import_topo_map.stringAttr)({
          attributeId: "reachName",
          label: "Watercourse name",
          buckets: "auto",
          showDistribution: false
        })
      ]
    }),
    naturalnessAttributes
  ]
});
const neLakeNaturalnessLayer = (0, import_topo_map.polygonLayer)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("neLakeNaturalness"),
  title: "New Lake Naturalness Data",
  source: neLakeNaturalnessSource,
  defaultAttribute: "physical",
  attributes: [
    (0, import_topo_map.attributeGroup)({
      label: "Location",
      attributes: [
        (0, import_topo_map.stringAttr)({
          attributeId: "lakeName",
          label: "Lake name",
          buckets: "auto",
          showDistribution: false
        })
      ]
    }),
    naturalnessAttributes
  ]
});
const drnAttribution = (0, import_topo_map.standardAttribution)({
  what: "DRN River Outlines",
  who: "Environment Agency",
  from: "2013",
  url: "https://data.gov.uk/dataset/14f5ab89-3b46-41e3-854b-ca0392136b82/detailed-river-network-nodes-afa036"
});
const priorityRiverHabitatLayer = (0, import_topo_map.lineLayer)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("PriorityRiverHabitat"),
  title: "Official Priority River Habitat Map",
  source: (0, import_topo_map.remoteGeojsonSource)({
    url: "https://opendata.arcgis.com/datasets/7e5dd3c72f424fd5bc6f013d18dd770c_0.geojson",
    attribution: [drnAttribution]
  }),
  attributes: [
    (0, import_topo_map.attributeGroup)({
      attributes: [
        (0, import_topo_map.featureAttr)({
          attributeId: "overall",
          label: "Official Priority River Habitat Map",
          marker: import_topo_map.marker.fromColor(priorityHabitatColor)
        })
      ]
    })
  ],
  primaryKey: "drn_id"
});
function lakeFeature(easting, northing, name, waterbodyId) {
  return {
    type: "Feature",
    geometry: (0, import_geometry.convertGeometry)((0, import_geometry.point)(easting, northing), import_geometry.osgb36ToWgs84),
    properties: { name, waterbodyId }
  };
}
const priorityLakeHabitatLayer = (0, import_topo_map.pointLayer)({
  layerId: (0, import_topo_map.unsafeMapLayerId)("PriorityLakeHabitat"),
  title: "Official Priority Lake Habitat Map",
  source: (0, import_topo_map.localGeojsonSource)({
    data: (0, import_geometry.featureCollection)({
      features: [
        lakeFeature(389331, 604639, "Linshiels Lake", 27556),
        lakeFeature(627971, 327104, "Captains Pond", 35397),
        lakeFeature(450318, 483202, "Gormire Lake", 29545),
        lakeFeature(360522, 558710, "Tindale Tarn", 28395),
        lakeFeature(389320, 466746, "Malham Tarn", 29844),
        lakeFeature(379042, 569740, "Broomlee Lough", 28172),
        lakeFeature(347788, 476625, "Hawes Water, Silverdale", 29647),
        lakeFeature(479326, 132385, "Cranmer Pond", 44464),
        lakeFeature(329132, 514093, "Blea Tarn", 29097),
        lakeFeature(334879, 512052, "Grisedale Tarn", 29129),
        lakeFeature(334808, 515262, "Red Tarn, Helvellyn", 29083),
        lakeFeature(315778, 496966, "Devoke Water", 29338),
        lakeFeature(318258, 515771, "Buttermere", 29052),
        lakeFeature(330917, 503218, "Little Langdale Tarn", 29231),
        lakeFeature(340275, 512729, "Brothers Water", 29116),
        lakeFeature(318382, 504378, "Burnmoor Tarn", 29215),
        lakeFeature(604074, 287550, "Kenninghall Fen", 37648),
        lakeFeature(334322, 435237, "Marton Mere", 30553),
        lakeFeature(553324, 379220, "Sea Bank Clay Pits", 32880),
        lakeFeature(636646, 318884, "Turf Fen or 'Reedham Water'", 35847),
        lakeFeature(588712, 296038, "West Mere", 37248),
        lakeFeature(322788, 509115, "Sprinkling Tarn", 29163),
        lakeFeature(333654, 531352, "Bowscale Tarn", 28854),
        lakeFeature(342534, 520438, "Ullswater", 28955),
        lakeFeature(638966, 313419, "Upton Broad", 36202),
        lakeFeature(333051, 500005, "Tarn Hows", 29275),
        lakeFeature(315798, 518895, "Crummock Water", 29e3),
        lakeFeature(419481, 562825, "Sibdon Pond Nature Reserve, Blaydon", 28314),
        lakeFeature(344861, 510746, "Blea Water", 29146),
        lakeFeature(432851, 548645, "Joes Pond", 28629),
        lakeFeature(632901, 305702, "Wheatfen Broad", 36722),
        lakeFeature(636191, 305540, "Buckenham Broad", 36732),
        lakeFeature(618691, 159919, "Fordwich lakes", 43164)
      ]
    }),
    attribution: [
      (0, import_topo_map.standardAttribution)({
        what: "Lake Outlines",
        who: "UK Lakes Portal",
        url: "https://eip.ceh.ac.uk/apps/lakes/"
      })
    ]
  }),
  attributes: [
    (0, import_topo_map.attributeGroup)({
      attributes: [
        (0, import_topo_map.featureAttr)({
          attributeId: "overall",
          label: "Official Priority Lake Habitat Map",
          marker: (0, import_topo_map.markerStyle)({
            normal: (0, import_topo_map.markerMode)({
              size: 1,
              fillColor: "#ffffff",
              strokeColor: "#0088dd",
              strokeWidth: 1
            }),
            selected: (0, import_topo_map.markerMode)({
              size: 1.5,
              fillColor: "#ffffff",
              strokeColor: "#0088dd",
              strokeWidth: 2
            })
          })
        })
      ]
    })
  ],
  primaryKey: "waterbodyId"
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  drnAttribution,
  neLakeNaturalnessLayer,
  neLakeNaturalnessSource,
  neRiverNaturalnessLayer,
  neRiverNaturalnessSource,
  priorityLakeHabitatLayer,
  priorityRiverHabitatLayer
});
//# sourceMappingURL=naturalnessHelpers.js.map
